<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">{{ '$edit_account$' | translate }}</h5>
    <button type="button" class="close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body pt-3">
    @if (userId) {
      <div class="container">
        <form [formGroup]="profileForm" (ngSubmit)="saveProfile()">
          <div class="row">
            <div class="col-12">
              <div class="card mb-4">
                <div class="card-body">
                  <div class="row">
                    <div class="col-12 col-lg-3 col-xl-2">
                      <div class="row justify-content-center">
                        <div class="col-auto">
                          <div class="select-avatar pt-3">
                            @if (profileForm.controls.avatarUrl.value) {
                              <span
                                class="avatar avatar-edit-user avatar-teal"
                                [style.background-image]="'url(' + profileForm.controls.avatarUrl.value + ')'">
                              </span>
                            } @else {
                              <div class="avatar avatar-edit-user avatar-teal">
                                <i class="material-icons mx-auto">person</i>
                              </div>
                            }
                          </div>
                        </div>
                        <div class="col-auto">
                          <strong class="btn btn-primary btn-capsule btn-sm upload-doc-btn mt-2">
                            {{ '$label_choose_file$' | translate }}
                            <input
                              #uploadImageButton
                              class="upload-doc-input"
                              type="file"
                              accept="image/*"
                              id="imageUrl"
                              (change)="uploadImage(uploadImageButton.files)" />
                          </strong>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-lg-9 col-xl-10">
                      <div class="row pt-3">
                        <div class="col-12 col-md-6">
                          <label for="firstName"
                            >{{ '$field_firstname$' | translate
                            }}<strong class="required-field-asterisk required">*</strong>
                          </label>
                          <input
                            formControlName="firstName"
                            type="text"
                            id="firstName"
                            name="firstName"
                            class="form-control"
                            minlength="1"
                            maxlength="255"
                            required
                            [placeholder]="'$field_firstname$' | translate" />
                          @if (showValidationErrors('firstName')) {
                            <div>
                              @if (profileForm.controls.firstName.errors?.required) {
                                <div>
                                  <p class="validation-message">{{ '$field_error_firstName_required$' | translate }}</p>
                                </div>
                              }
                            </div>
                          }
                        </div>
                        <div class="col-12 col-md-6">
                          <label for="lastName"
                            >{{ '$field_lastname$' | translate
                            }}<strong class="required-field-asterisk required">*</strong>
                          </label>
                          <input
                            formControlName="lastName"
                            type="text"
                            name="lastName"
                            id="lastName"
                            class="form-control"
                            minlength="1"
                            maxlength="255"
                            required
                            [placeholder]="'$field_lastname$' | translate" />
                          @if (showValidationErrors('lastName')) {
                            <div>
                              @if (profileForm.controls.lastName.errors?.required) {
                                <div>
                                  <p class="validation-message">{{ '$field_error_lastName_required$' | translate }}</p>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      </div>
                      <div class="row pt-2">
                        <div class="col-12 col-md-6">
                          <label for="">{{ '$email$' | translate }}</label>
                          <div class="position-relative">
                            <input
                              formControlName="email"
                              type="text"
                              id="email"
                              name="email"
                              class="form-control ng-untouched ng-pristine"
                              [placeholder]="'$email_placeholder$' | translate" />
                          </div>
                        </div>
                        <div class="col-12 col-md-6">
                          <label for="phone">{{ '$field_phone$' | translate }}</label>
                          <div class="position-relative">
                            <input
                              formControlName="phone"
                              type="text"
                              id="phone"
                              name="phone"
                              class="form-control ng-untouched ng-pristine"
                              [placeholder]="'$phone_placeholder$' | translate" />
                          </div>
                        </div>
                      </div>
                      <div class="row pt-2">
                        <div class="col-12 col-md-6">
                          <label for="enable-notifications-via-mail">{{
                            '$enable_notifications_via_mail$' | translate
                          }}</label>
                          <div class="custom-control custom-checkbox mt-2">
                            <input
                              formControlName="enableNotificationsViaMail"
                              class="custom-control-input"
                              type="checkbox"
                              id="enableNotificationsViaMail"
                              name="enableNotificationsViaMail" />
                            <label class="custom-control-label pl-1" for="enableNotificationsViaMail"></label>
                          </div>
                        </div>
                        <div class="col-12 col-md-6">
                          <label for="language-select">{{ '$field_default_language$' | translate }}</label>
                          <app-language-select formControlName="languageCode" />
                        </div>
                      </div>

                      @if (!isSelfProfile || canEditRoles()) {
                        <div class="row pt-2">
                          @if (!isSelfProfile) {
                            <div class="col-12 col-md-6">
                              <label for="externalReference">
                                {{ '$field_externalreference$' | translate }}
                              </label>
                              <input
                                formControlName="externalReference"
                                type="text"
                                class="form-control"
                                minlength="1"
                                maxlength="255"
                                id="externalReference"
                                name="externalReference"
                                [placeholder]="'$field_externalreference$' | translate" />
                            </div>
                          }
                          @if (canEditRoles()) {
                            <div class="col-12 col-md-6">
                              <div class="form-group">
                                <label for="roleTypes"
                                  >{{ '$field_role$' | translate }}
                                  <strong class="required-field-asterisk required">*</strong></label
                                >
                                <app-role-select formControlName="roleTypes" [roles]="roleTypes" />
                                @if (showValidationErrors('roleTypes')) {
                                  <div>
                                    @if (profileForm.controls.roleTypes.errors?.required) {
                                      <div>
                                        <p class="validation-message">
                                          {{ '$field_error_userRole_required$' | translate }}
                                        </p>
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            </div>
                          }
                        </div>
                      }
                      @if (canEditRoles()) {
                        <div class="row pt-2">
                          <div class="col-12 col-md-3">
                            <div class="form-group">
                              <label for="isAgentAdmin">{{ '$isagentadmin$' | translate }}</label>
                              <div class="custom-control custom-checkbox mt-2">
                                <input
                                  formControlName="isAgentAdmin"
                                  class="custom-control-input"
                                  type="checkbox"
                                  id="isAgentAdmin"
                                  name="isAgentAdmin" />
                                <label class="custom-control-label pl-1" for="isAgentAdmin"></label>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-3">
                            <div class="form-group">
                              <label for="isTodoOwner">{{ '$istodoowner$' | translate }}</label>
                              <div class="custom-control custom-checkbox mt-2">
                                <input
                                  formControlName="isTodoOwner"
                                  class="custom-control-input"
                                  type="checkbox"
                                  id="isTodoOwner"
                                  name="isTodoOwner" />
                                <label class="custom-control-label pl-1" for="isTodoOwner"></label>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-6">
                            <div class="form-group">
                              <label for="warehouses">{{ '$title_employee_warehouses$' | translate }}</label>
                              <div class="custom-select-wrapper">
                                <p-multiSelect
                                  formControlName="warehouses"
                                  optionLabel="name"
                                  id="warehouses"
                                  name="warehouses"
                                  [options]="warehouses"
                                  [placeholder]="'$no_warehouse_selected$' | translate">
                                  <ng-template let-warehouses pTemplate="selectedItems">
                                    @for (warehouse of warehouses; track warehouse.id) {
                                      <div>
                                        {{ warehouse.name | translate }}
                                      </div>
                                    }
                                  </ng-template>
                                  <ng-template let-warehouse pTemplate="item">
                                    {{ warehouse.name | translate }}
                                  </ng-template>
                                </p-multiSelect>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row justify-content-between">
            <div class="col-auto">
              <div class="form-group buttons text-right mt-0">
                <button type="button" class="btn btn-secondary btn-capsule" (click)="cancelEdit()">
                  {{ '$button_cancel$' | translate }}
                </button>
              </div>
            </div>
            <div class="col-auto">
              <div class="form-group buttons text-right mt-0">
                <button
                  type="submit"
                  class="btn btn-primary btn-capsule"
                  [disabled]="!profileForm.valid || profileForm.pristine">
                  <span>{{ '$button_savechanges$' | translate }}</span
                  ><i class="material-icons mi-inline">check</i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    }
  </div>
</div>
